// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__s84K4","title":"styles_title__dUitD","description":"styles_description__bYtn6"};